module.exports = __webpack_public_path__ + "static/icons/icon-map--france-9c119c2b065803a50bd1a23726418a64.svg";